'use strict';

/**
 *
 * @name: nnXPosts
 *
 **/

import DirectiveTemplate from './nn-x-posts.directive.html';

function NnXPostsDirective() {

  'ngInject';

  return {
    restrict: 'EA',
    replace: true,
    scope: {
      content: '&',
      loaded: '='
    },
    template: DirectiveTemplate,
    controller: nnXPostsController,
    controllerAs: 'postsList'
  };
}

function nnXPostsController(
  $scope,
  $timeout,
  apiModulesService,
  transObject,
  apiPostService
) {

  'ngInject';

  /**
   *
   * @CONFIG
   *
   */

  /*jshint validthis: true */
  var postsList = this;
  postsList.content = $scope.content();
  postsList.data = (apiModulesService.checkIfModuleHasData(postsList.content) && postsList.content.posts.length) ? postsList.content.posts : undefined;

  /**
   *
   * @PUBLIC_METHODS
   *
   */

  /**
   *
   * @PRIVATE_METHODS
   *
   */

  function _translatePosts() {

    postsList.data.forEach(function(post) {

      transObject.translate(post);
      transObject.trueSlug(post);
      return post;
    });
  }

  function _loadPosts(options) {

    options.order = typeof options.order !== 'undefined' ? options.order : false;
    options.categoryId = typeof options.categoryId !== 'undefined' ? options.categoryId : false;

    return apiPostService
      .getPost(

        options.categoryId, // categoryId,
        options.order, // order,
        1, // page,
        4, // limit,
        false, // lovedBy,
        false, // viewedBy,
        true, // isPublished,
        false, // bookmarkedBy,
        false, // contributedBy,
        false, // seriesId,
        false, // playlistId,
        false, // includeImages,
        false, // includeComingSoon,
        false, // isDaily,
        false, // sponsorId,
        false, // tagId,
        true, // nownessPicks,
        false, // chronology,
        false, // slug,
        false // includeExclusivePicks
      )
      .then(function(res) {

        // postsList.data = postsList.data || [];
        postsList.data = res.data.items;
      });
  }

  /**
   *
   * @INIT
   *
   */

  if (typeof postsList.data !== 'undefined') {

    _translatePosts();
  } else {

    var options = apiModulesService.getModuleQueryForApiCall(postsList.content);

    _loadPosts(options)
      .then(function() {

        _translatePosts();
      });
  }
}

export default NnXPostsDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-x-posts/nn-x-posts.directive.js